import React from 'react';
import { dummyClick } from '../../utilities';
import IconButton from './IconButton';

const SocialActions = ({ onLike, onFB, onTwitter, onCopyLink, liked, like, share }) => (
  <div className="social-actions">
    <div className="flex justify-around t-mt4">
      <div className="tc">
        <p className="b">{like}</p>
        <IconButton
          icon={`/images/pop-like-icon${liked ? '' : '_outline'}.svg`}
          onClick={onLike}
          className={`${ liked ? '' : 'heartbeat'}`}
        />
      </div>
      <div className="tc">
        <p className="b">{share}</p>
        <IconButton icon="/images/webreader/ic-fb.svg" className="t-mr2 t-mr3-ns" onClick={onFB}/>
        <IconButton icon="/images/webreader/ic-twitter.svg" className="t-mr2 t-mr3-ns" onClick={onTwitter}/>
        <IconButton icon="/images/webreader/link.svg" onClick={onCopyLink} />
      </div>
    </div>
  </div>
)

SocialActions.defaultProps = {
  onLike: dummyClick,
  onFB: dummyClick,
  onTwitter: dummyClick,
  onCopyLink: dummyClick,
  liked: false,
  like: 'EN Give a like',
  share: 'EN Share with Friends'
};

export default SocialActions;
